import { V3dTools } from '@/v3d/common';
import { Color, CubeTexture, Group, Object3D, Texture, Vector3 } from 'three';
import { IV3D } from '@/Interfaces/v3d';
import { iApp } from '@/Interfaces/app';
import { ToolChest } from '@/Engine/ToolChest';
import { FileDispatcher } from '@/libs/FileDispatcher';
import { type GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { ModelCache } from '@/Engine/modelCache';


declare let v3d: IV3D;
export class GlobalState {
    loader: FileDispatcher;
    gltfLoader!: GLTFLoader;
    container?: HTMLElement;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    v3dTools: V3dTools;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    app: iApp;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    camera: Camera;
    sceneBackGround: Color | Texture | CubeTexture | null | undefined;
    pauseRender = false;
    replaceShelfToNewModule = false;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    render: (cb?: ()=>void)=>void;
    continueRender: (() => void);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    toolChest?: ToolChest|null = null;
    // курсор мышки
    pointer = new v3d.Vector2();
    // pointerVirtual курсор связанный с комплектующи
    // (позиция, которая повторяет траекторию курсора, но находится на объекте для того, чтоб установить комплектующее в эту точку)
    pointerVirtual: Vector3 = new v3d.Vector3();
    positionStartPointer: Vector3 | null = new v3d.Vector3();
    selectedModel: Group|Object3D|null = null;
    ctrlKey = false;
    isChangeChpu = null;
    isUpdateStore = true;
    moved = false;
    up = false;
    down = false;
    initConfigurator = false;
    objWithoutWall = false;
    isProcessUpdate = false;
    isNeedUpdate = false;
    isUpdateLoadModel = true;
    modelCache?: ModelCache;
    constructor() {
        this.loader = new FileDispatcher();
        this.continueRender = () => {};
        this.render = () => {};
    }
}

export const $ = new GlobalState();

